import { useCallback, useEffect, useState } from "react";
import { getChickenConfigApi, getChickenActiveApi } from "../api/chickenApi";

// GET /chicken/config + GET /chicken/active -> { config, activeRound, loading, error, reload }
export default function useChickenConfig() {
  const [config, setConfig] = useState(null);
  const [activeRound, setActiveRound] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getChickenConfigApi();
      const body = res.data;
      if (!body?.success || !body?.data?.difficulties) {
        throw new Error(body?.message || "Config load nahi hui.");
      }
      setConfig(body.data);

      // config ke baad active round check (fail ho to game normal start hoga)
      try {
        const a = await getChickenActiveApi();
        setActiveRound(a.data?.success ? a.data.data || null : null);
      } catch {
        setActiveRound(null);
      }
    } catch (e) {
      setError(
        !e.response && e.message === "Network Error"
          ? "Backend se connect nahi ho paya. localhost:5000 chal raha hai?"
          : e.response?.data?.message || e.message || "Config load nahi hui.",
      );
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { config, activeRound, loading, error, reload: load };
}
